<ng-container *ngIf="alert">
  <div class="alertCard__cont">
    <div class="alertCard__cont__header">
      <div class="alertCard__cont__header__trip">
        <div class="alertCard__cont__header__trip__icon">
          <app-ds-icon
            [icon]="iconPlane"
            [color]="iconFillColor.Primary"
            [size]="20">
          </app-ds-icon>
        </div>
        <app-ds-typography
          [fontFamily]="semiBoldFontFamily"
          [size]="labelSize$ | async"
          [color]="typographyColor.Primary"
          [text]="alert.departure_name">
        </app-ds-typography>
        <div class="alertCard__cont__header__trip__type">
          <app-ds-icon
            [icon]="tripIcon"
            [color]="iconFillColor.Primary"
            [size]="14">
          </app-ds-icon>
        </div>
        <app-ds-typography
          [fontFamily]="semiBoldFontFamily"
          [size]="labelSize$ | async"
          [color]="typographyColor.Primary"
          [text]="alert.arrival_name">
        </app-ds-typography>
      </div>
      <div class="alertCard__cont__header__actions">
        <div class="alertCard__cont__header__actions__action alertCard__cont__header__actions__action--edit">
          <app-ds-icon
            [icon]="iconEditOutline"
            [color]="iconFillColor.Primary"
            [size]="16"
            (click)="editAlert.emit(alert)">
          </app-ds-icon>
        </div>
        <div class="alertCard__cont__header__actions__action alertCard__cont__header__actions__action--remove">
          <app-ds-icon
            [icon]="iconTrash"
            [color]="iconFillColor.Primary"
            [size]="16"
            (click)="toggleConfirmForm()">
          </app-ds-icon>
        </div>
      </div>
    </div>
    <div class="alertCard__cont__divider">
      <app-ds-divider></app-ds-divider>
    </div>
    <div class="alertCard__cont__info">
      <div class="alertCard__cont__info__dates__departure">
        <div class="alertCard__secondary-text">
          <app-ds-typography
            [size]="xxxsFontSize"
            [color]="typographyColor.Primary"
            [text]="departureTitle | transloco">
          </app-ds-typography>
        </div>
        <app-ds-typography
          [fontFamily]="semiBoldFontFamily"
          [size]="labelSize$ | async"
          [color]="typographyColor.Primary"
          [text]="
            withFlexDatesInAlert ?
            ((outboundMin | date: 'dd MMM' | dateFormat | capitalize) + ' - ' + (outboundMax | date: 'dd MMM' | dateFormat | capitalize)) :
            (departureDate | date: 'EE, dd MMM' | dateFormat | capitalize)
          ">
        </app-ds-typography>
      </div>
      <ng-container *ngIf="!isOneWay">
        <div class="alertCard__cont__info__dates__arrival">
          <div class="alertCard__secondary-text">
            <app-ds-typography
              [size]="xxxsFontSize"
              [color]="typographyColor.Primary"
              [text]="arrivaTitle | transloco">
            </app-ds-typography>
          </div>
          <app-ds-typography
            [fontFamily]="semiBoldFontFamily"
            [size]="labelSize$ | async"
            [color]="typographyColor.Primary"
            [text]="
              withFlexDatesInAlert ?
              ((inboundMin | date: 'dd MMM' | dateFormat | capitalize) + ' - ' + (inboundMax | date: 'dd MMM' | dateFormat | capitalize)) :
              (arrivalDate | date: 'EE, dd MMM' | dateFormat | capitalize)
            ">
          </app-ds-typography>
        </div>
      </ng-container>
      <div class="alertCard__cont__info__scales">
        <div class="alertCard__secondary-text">
          <app-ds-typography
            [size]="xxxsFontSize"
            [color]="typographyColor.Primary"
            [text]="'GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.SCALES' | transloco">
          </app-ds-typography>
        </div>
        <app-ds-typography
          [fontFamily]="semiBoldFontFamily"
          [size]="labelSize$ | async"
          [color]="typographyColor.Primary"
          [text]="'GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.'  + connectionType | transloco">
        </app-ds-typography>
      </div>
    </div>
    <div class="alertCard__cont__divider">
      <app-ds-divider></app-ds-divider>
    </div>
    <div class="alertCard__cont__footer">
      <div class="alertCard__cont__footer__price-info" [class.expired]="expiredAlert">
        <div class="alertCard__secondary-text">
          <app-ds-typography
            [size]="xxxsFontSize"
            [color]="typographyColor.Primary"
            [text]="'GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.PRICE_LABEL' | transloco">
          </app-ds-typography>
        </div>
        <app-ds-typography
          [fontFamily]="semiBoldFontFamily"
          [size]="labelSize$ | async"
          [color]="typographyColor.Primary"
          [text]="numberPrice(alert.price_max) | currencyFormat: alert.currency">
        </app-ds-typography>
      </div>
      <div class="alertCard__cont__footer__button" *ngIf="!expiredAlert">
        <app-ds-button
          [size]="buttonSize"
          [labels]="{ ButtonLabel: 'GENERAL_WIDGET_MODULE.ALERTS.ALERT_LIST.SEE_FLIGHTS' | transloco }"
          (clickEvent)="openFlights.emit(alert)">
        </app-ds-button>
      </div>
    </div>
  </div>
</ng-container>

<app-swipe-up
  [height]="95"
  [showSwipeUp]="showSwipeUp"
  [title]="'GENERAL_WIDGET_MODULE.ALERTS.DELETE.FORM_MAX_TITLE' | transloco"
  [showHeader]="true"
  (toggleShowSwipeUp)="toggleConfirmForm()">
  <ng-container content *ngIf="showSwipeUp">
    <app-delete-alert-form
      [alert]="alert"
      (removeAlertEvent)="removeAlert()"
      (toggleConfirmFormEvent)="toggleConfirmForm()">
    </app-delete-alert-form>
  </ng-container>
</app-swipe-up>
